const n = (t) => ({
  type: "FeatureCollection",
  features: t.map((e) => ({
    type: "Feature",
    id: e.stationCode ? e.stationCode : 0,
    geometry: {
      type: "Point",
      /*
                for some RANDOM reason GeoJson uses [lng, lat] instead of [lat, lng] like
                the rest of the world and uses array so the types won't catch the problem.
      
                "The first two elements are longitude and latitude, or
                easting and northing, precisely in that order and using decimal
                numbers.""
              */
      coordinates: [e.longitude ? e.longitude : 0, e.latitude ? e.latitude : 0]
    },
    properties: {
      station: e
    }
  }))
}), r = (t) => {
  switch (t?.stationType) {
    case "01 Bemannad":
    case "02 Automat":
      return t.stationConcept === "22 Uno X Truck" || t.stationConcept === "21 Uno X" ? "Uno X" : t.stationConcept === "20 Preem Truck YX" ? "YX" : "Preem";
    case "03 TRUCK":
      return "Såifa";
    default:
      return "Preem";
  }
};
export {
  n as convertStationsToGeoJson,
  r as getMarkerTypeForStation
};
